import { ComponentProps } from 'react';
import styled from 'styled-components';

import { AnchorButton } from 'components/Button/AnchorButton';
import { colors } from 'theme';

type Props = ComponentProps<typeof AnchorButton>;

export const StyledButton = styled(AnchorButton)<Props>`
  &.secondary {
    border: 1px solid ${colors.mediumContentGrey};
    color: ${colors.mediumContentGrey};
  }
  &.secondary,
  &.danger-outline {
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  &.secondary:hover {
    background-color: ${(props) =>
      props.variant === 'danger-outline' ? colors.alertRed : colors.inputGrey};
  }
`;

export const TextContainer = styled.div`
  margin-left: 12px;
`;
